const CarouselImagesIcon = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M432,112V96a48.14,48.14,0,0,0-48-48H64A48.14,48.14,0,0,0,16,96V352a48.14,48.14,0,0,0,48,48H80"
        fill="none"
        stroke="#000000"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <rect
        x="96"
        y="128"
        width="400"
        height="336"
        rx="45.99"
        ry="45.99"
        fill="none"
        stroke="#000000"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <ellipse
        cx="372.92"
        cy="219.64"
        rx="30.77"
        ry="30.55"
        fill="none"
        stroke="#000000"
        strokeMiterlimit={10}
        strokeWidth="32px"
      />
      <path
        d="M342.15,372.17,255,285.78a30.93,30.93,0,0,0-42.18-1.21L96,387.64"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <path
        d="M265.23,464,383.82,346.27a31,31,0,0,1,41.46-1.87L496,402.91"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
    </svg>
  );
};

export default CarouselImagesIcon;
